// const URL_TESTING = `http://54.251.66.247`;
// const URL_TESTING = `http://localhost:8080`;
// const URL_REMOTE = `https://sampathathukorala.edulab.lk`;
// const URL_REMOTE = `https://teachme.ceyentra.lk`;
// const URL_REMOTE = `https://demoadmin.edulab.lk`;
// const URL_REMOTE = `https://newleedswaapi.edulab.lk`;
const URL_REMOTE = `https://apis.edulab.lk`;
const conf = {
  serverUrl:  URL_REMOTE,
  // basePath: `demoenglish/v1`,
  basePath: `cjmaths/v1`,
  // basePath: `oracleacademy/v1`,
  redirect: `https://institute.edulab.lk`,
  // redirect: `https://demo2.edulab.lk`,
  // redirect: `http://www.oracle.lk/`,
};

export default conf;
